import { useContext } from "react"

import { PageContext, isProjectPageContext } from "shared/context/PageContext"

export function useProjectPageContext(projectID: string | null) {
  const context = useContext(PageContext)

  const projectPageContext = isProjectPageContext(context) ? context : null
  return {
    isCurrentPage: projectPageContext
      ? projectPageContext.id === projectID
      : false,
    context: projectPageContext
  }
}
